const TipoPersona = {
  PF: { valor: "PF", descripcion: "PF" },
  PJ: { valor: "PJ", descripcion: "PJ" },
};

export default TipoPersona;
